import Head from "next/head";
import { PricingLanding } from "components/organisms/PricingLanding";
export default function PricingPage() {
  return <>
            <Head data-sentry-element="Head" data-sentry-source-file="index.tsx">
                <title>
                    CharGen: Affordable Pricing for D&D AI Character Generator
                    Images
                </title>
                <meta name="description" content="Explore our affordable pricing options for the best AI Image Generator for high-quality AI Generated Images for your RPG Characters." data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:title" key="og:title" content="CharGen: Affordable Pricing for D&D AI Character Generator Images" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:description" key="og:description" content="Explore our affordable pricing options for the best AI Image Generator for high-quality AI Generated Images for your RPG Characters." data-sentry-element="meta" data-sentry-source-file="index.tsx" />
                <meta property="og:url" key="og:url" content="https://char-gen.com/pricing" data-sentry-element="meta" data-sentry-source-file="index.tsx" />
            </Head>
            <PricingLanding data-sentry-element="PricingLanding" data-sentry-source-file="index.tsx" />
        </>;
}